export const STANDARD = 0
export const FREE = 1
export const GREEN = 2
export const USER = 3

const parkingTypes = [
  {
    id: 0,
    name: "Partner",
  },
  {
    id: 1,
    name: "Free",
  },
  {
    id: 2,
    name: "Green",
  },
  {
    id: 3,
    name: "User",
  }
]

export default parkingTypes
